import { createFileRoute } from '@tanstack/react-router'
import { ExpensesListPage } from '../../../features/finance/expenses-list-page'
import { expenseSearchSchema } from '../../../features/finance/search'

export const Route = createFileRoute('/_app/expenses/')({
  validateSearch: expenseSearchSchema,
  component: ExpensesListPage,
})
